import {ROUTES as REFRA_FEATURE_ROUTES} from '@refra/modules/routing/routes'
import {Navigate} from 'react-router'

export const RefraPlannerTabRedirect: React.FC = () => {
  // Since in RefraPlannerPlantPage we've already checked user "view" permissions
  // redirecting to the first available tab, which is Refra Catalog
  return <Navigate to={REFRA_FEATURE_ROUTES.REFRA_CATALOG.path} replace />
}
